var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-0",class:[
    _vm.titleClass,
    _vm.showBorderBottom?'border-bottom':'',
    _vm.borderType,
    _vm.paddingContainerHeader
  ]},[_c('div',{staticClass:"d-flex justify-content-between w-100"},[_c('div',{staticClass:"d-flex align-items-center w-100"},[_vm._t("default",function(){return [_vm._t("preffixTitle"),_vm._v("  "+_vm._s(_vm.text)+" "),_vm._t("suffixTitle")]})],2),_vm._v(" "),_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }